import React from 'react';

interface MarketplaceIconProps {
  isActive: boolean;
  color?: string;
}

export function MarketplaceIcon({
  isActive = false,
  color,
}: MarketplaceIconProps) {
  return isActive ? getActiveIcon(color) : getInActiveIcon(color);
}

function getActiveIcon(color?: string) {
  const currentColor = color || "#14BBD1";
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      style={{ color: currentColor }}>
      <path
        d="M11.9402 2.21001L9.5302 7.82001H7.1202C6.7202 7.82001 6.3302 7.85001 5.9502 7.93001L6.9502 5.53001L6.9902 5.44001L7.0502 5.28001C7.0802 5.21001 7.1002 5.15001 7.1302 5.10001C8.2902 2.41001 9.5902 1.57001 11.9402 2.21001Z"
        fill={currentColor}
      />
      <path
        d="M18.7301 8.09002L18.7101 8.08002C18.1101 7.91002 17.5001 7.82002 16.8801 7.82002H10.6201L12.8701 2.59002L12.9001 2.52002C13.0401 2.57002 13.1901 2.64002 13.3401 2.69002L15.5501 3.62002C16.7801 4.13002 17.6401 4.66002 18.1701 5.30002C18.2601 5.42002 18.3401 5.53002 18.4201 5.66002C18.5101 5.80002 18.5801 5.94002 18.6201 6.09002C18.6601 6.18002 18.6901 6.26002 18.7101 6.35002C18.8601 6.86002 18.8701 7.44002 18.7301 8.09002Z"
        fill={currentColor}
      />
      <path
        d="M12.52 17.66H12.77C13.07 17.66 13.32 17.39 13.32 17.06C13.32 16.64 13.2 16.58 12.94 16.48L12.52 16.33V17.66Z"
        fill={currentColor}
      />
      <path
        d="M18.2902 9.52001C17.8402 9.39001 17.3702 9.32001 16.8802 9.32001H7.12023C6.44023 9.32001 5.80023 9.45001 5.20023 9.71001C3.46023 10.46 2.24023 12.19 2.24023 14.2V16.15C2.24023 16.39 2.26023 16.62 2.29023 16.86C2.51023 20.04 4.21023 21.74 7.39023 21.95C7.62023 21.98 7.85023 22 8.10023 22H15.9002C19.6002 22 21.5502 20.24 21.7402 16.74C21.7502 16.55 21.7602 16.35 21.7602 16.15V14.2C21.7602 11.99 20.2902 10.13 18.2902 9.52001ZM13.2802 15.5C13.7402 15.66 14.3602 16 14.3602 17.06C14.3602 17.97 13.6502 18.7 12.7702 18.7H12.5202V18.92C12.5202 19.21 12.2902 19.44 12.0002 19.44C11.7102 19.44 11.4802 19.21 11.4802 18.92V18.7H11.3902C10.4302 18.7 9.64023 17.89 9.64023 16.89C9.64023 16.6 9.87023 16.37 10.1602 16.37C10.4502 16.37 10.6802 16.6 10.6802 16.89C10.6802 17.31 11.0002 17.66 11.3902 17.66H11.4802V15.97L10.7202 15.7C10.2602 15.54 9.64023 15.2 9.64023 14.14C9.64023 13.23 10.3502 12.5 11.2302 12.5H11.4802V12.28C11.4802 11.99 11.7102 11.76 12.0002 11.76C12.2902 11.76 12.5202 11.99 12.5202 12.28V12.5H12.6102C13.5702 12.5 14.3602 13.31 14.3602 14.31C14.3602 14.6 14.1302 14.83 13.8402 14.83C13.5502 14.83 13.3202 14.6 13.3202 14.31C13.3202 13.89 13.0002 13.54 12.6102 13.54H12.5202V15.23L13.2802 15.5Z"
        fill={currentColor}
      />
      <path
        d="M10.6802 14.14C10.6802 14.56 10.8002 14.62 11.0602 14.72L11.4802 14.87V13.54H11.2302C10.9202 13.54 10.6802 13.81 10.6802 14.14Z"
        fill={currentColor}
      />
    </svg>
  );
}

function getInActiveIcon(color?: string) {
  const currentColor = color || "#B0B0B0";
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      style={{ color: currentColor }}>
      <path
        d="M12.66 2.51814L12.63 2.58814L9.72996 9.31814H6.87996C6.19996 9.31814 5.54996 9.45814 4.95996 9.70814L6.70996 5.52814L6.74996 5.42814L6.81996 5.26814C6.83996 5.20814 6.85996 5.14814 6.88996 5.09814C8.19996 2.06814 9.67996 1.37814 12.66 2.51814Z"
        stroke={currentColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.05 9.51813C17.6 9.37813 17.12 9.31813 16.64 9.31813H9.72998L12.63 2.58813L12.66 2.51813C12.81 2.56813 12.95 2.63813 13.1 2.69813L15.31 3.62813C16.54 4.13813 17.4 4.66813 17.92 5.30813C18.02 5.42813 18.1 5.53813 18.17 5.66813C18.26 5.80813 18.33 5.94813 18.37 6.09813C18.41 6.18813 18.44 6.27813 18.46 6.35813C18.73 7.19813 18.57 8.22813 18.05 9.51813Z"
        stroke={currentColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.5217 14.1984V16.1484C21.5217 16.3484 21.5117 16.5484 21.5017 16.7484C21.3117 20.2384 19.3617 21.9984 15.6617 21.9984H7.86172C7.62172 21.9984 7.38172 21.9784 7.15172 21.9484C3.97172 21.7384 2.27172 20.0384 2.06172 16.8584C2.03172 16.6284 2.01172 16.3884 2.01172 16.1484V14.1984C2.01172 12.1884 3.23172 10.4584 4.97172 9.70836C5.57172 9.45836 6.21172 9.31836 6.89172 9.31836H16.6517C17.1417 9.31836 17.6217 9.38836 18.0617 9.51836C20.0517 10.1284 21.5217 11.9884 21.5217 14.1984Z"
        stroke={currentColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.71 5.52814L4.96 9.70814C3.22 10.4581 2 12.1881 2 14.1981V11.2681C2 8.42814 4.02 6.05814 6.71 5.52814Z"
        stroke={currentColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.5186 11.2677V14.1977C21.5186 11.9977 20.0586 10.1277 18.0586 9.52766C18.5786 8.22766 18.7286 7.20766 18.4786 6.35766C18.4586 6.26766 18.4286 6.17766 18.3886 6.09766C20.2486 7.05766 21.5186 9.02766 21.5186 11.2677Z"
        stroke={currentColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
